import React, { Component } from 'react';
import { connect } from "react-redux";
import MasonryItem from './MasonryItem';
import ScrollableAnchor from 'react-scrollable-anchor';
import { configureAnchors } from 'react-scrollable-anchor';

configureAnchors({offset: -130, scrollDuration: 200});

class Grid extends Component {

  render() {

    return (
      <div>
        <ScrollableAnchor id={'active-grid'}>
        <div className="masonry-selected-container">
          <div className="staff-card-active">
            <img src={this.props.image} title={this.props.title} alt={this.props.title} />
            <h3>{this.props.title}</h3>
          </div>
          <p>{this.props.firstcopy} <em>{this.props.italics}</em> {this.props.endcopy}</p>
        </div>
        </ScrollableAnchor>
        <div className="row">
          <div className={"staff-container clearfix"}>
            <MasonryItem />
          </div>
        </div>
      </div>
    );
  }
}

const mapState = (state) => {
  return {
    image: state.leadTheWay.image,
    title: state.leadTheWay.title,
    firstcopy: state.leadTheWay.firstcopy,
    italics: state.leadTheWay.italics,
    endcopy: state.leadTheWay.endcopy,
  }
};

export default connect(mapState)(Grid);



// WEBPACK FOOTER //
// ./src/components/LeadTheWay/Grid/Grid.js